<div class="header">
  <button
    pButton
    (click)="backButton()"
    class="back-button"
    severity="secondary"
    icon="ph ph-caret-left"
    aria-label="Back"></button>
  <dk-progress-bar [progressValues]="[100, 100, 33.33]"></dk-progress-bar>
  <span class="title-text">{{ 'doktar_app.auth.register.about.title' | translate }}</span>
  <span class="subtitle-text">
    {{ 'doktar_app.auth.register.about.subtitle' | translate }}
  </span>
</div>

<span class="name-input-label">
  {{ 'doktar_app.common.name' | translate }}
</span>
<input
  type="text"
  pInputText
  [(ngModel)]="registerModal.name"
  class="name-input-text"
  [placeholder]="'doktar_app.common.name_placeholder' | translate" />

<span class="surname-input-label">
  {{ 'doktar_app.common.surname' | translate }}
</span>
<input
  type="text"
  pInputText
  [(ngModel)]="registerModal.surname"
  class="surname-input-text"
  [placeholder]="'doktar_app.common.surname_placeholder' | translate" />

<div class="about-buttons">
  <dk-button
    class="continue-button"
    [size]="'xlarge'"
    [label]="'doktar_app.common.continue' | translate"
    [disabled]="!registerModal.name || !registerModal.surname"
    (onClick)="continueAboutStep()"></dk-button>
</div>
